module.exports = __webpack_public_path__ + "img/programs_minimal.d7d2739f.png";